import { render, staticRenderFns } from "./W12V1.vue?vue&type=template&id=0a97cdb0&scoped=true&"
import script from "./W12V1.vue?vue&type=script&lang=js&"
export * from "./W12V1.vue?vue&type=script&lang=js&"
import style0 from "./W12V1.vue?vue&type=style&index=0&id=0a97cdb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a97cdb0",
  null
  
)

export default component.exports